export const CDN_URL = "https://d1ds5rzn7liqmq.cloudfront.net";

export const getDocumentsRequiredIcon = (iconName: string) =>
	`${CDN_URL}/documents-icons/${iconName ?? "Generic Doc.png"}`;

export const DOCUMENT_TAG_MAP: Record<
	Exclude<PopulatedQuestion["doc_tag"], null | undefined>,
	{
		label: string;
	}
> = {
	BUSINESS: {
		label: "Business"
	},
	FINANCIAL: {
		label: "Financial"
	},

	OCCUPATIONAL: {
		label: "Occupational"
	},
	PERSONAL: {
		label: "Personal"
	},
	TRAVEL: {
		label: "Travel"
	},
	MISCC: {
		label: "Miscellaneous"
	}
};

